import * as React from "react";
const SvgArrowRightS = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "m16 12-6 6V6z" })));
export default SvgArrowRightS;
//# sourceMappingURL=ArrowRightS.js.map